export class ChegSetDto {
  state: string | null = '';
  carrier: string | null = '';
  locality: string | null = '';
  comments: string | null = '';
  optionType: number = 0;
}
